import React from 'react';
import './TextInput.css';

interface TextInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel';
  required?: boolean;
  error?: string;
  multiline?: boolean;
  rows?: number;
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  type = 'text',
  required = false,
  error,
  multiline = false,
  rows = 4
}) => {
  const id = React.useId();
  
  return (
    <div className="text-input">
      <label htmlFor={id} className="text-input__label">
        {label}
        {required && <span className="text-input__required">*</span>}
      </label>
      
      {multiline ? (
        <textarea
          id={id}
          className={`text-input__field text-input__textarea ${error ? 'text-input__field--error' : ''}`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
      ) : (
        <input
          id={id}
          type={type}
          className={`text-input__field ${error ? 'text-input__field--error' : ''}`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
      )}
      
      {error && (
        <div id={`${id}-error`} className="text-input__error">
          {error}
        </div>
      )}
    </div>
  );
};
